import type { ComponentType, FC } from 'react';
import Button from '@components/Button';
import Tooltip from '@components/Tooltip';

interface SortToggleButtonProps {
  actionLabel: string;
  icon: ComponentType<{ className?: string }>;
  onClick: () => void;
  dataTestId?: string;
}

export const SortToggleButton: FC<SortToggleButtonProps> = ({ actionLabel, icon: Icon, onClick, dataTestId }) => (
  <Tooltip content={actionLabel}>
    <Button
      aria-label={actionLabel}
      data-testid={dataTestId}
      kind="secondary"
      className="h-[30px] w-[30px] px-0"
      onClick={onClick}
    >
      <Icon className="h-4 w-4" />
    </Button>
  </Tooltip>
);
